module.exports = __webpack_public_path__ + "static/media/3.d3b92bdf.jpg";